var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPointTwoicon = function SvgPointTwoicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.25,
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.575 11.45v-.79c0-.09.04-.17.11-.23l2.62-2.45c.46-.43.69-.87.69-1.31 0-.64-.42-1.04-1.07-1.04-.64 0-1.07.38-1.14 1.07-.01.12-.04.15-.13.15h-.95c-.08 0-.12-.05-.12-.15.03-1.21.94-2.25 2.34-2.25 1.41 0 2.29.87 2.29 2.15 0 .92-.35 1.44-1.1 2.16l-1.71 1.61h2.92c.07 0 .1.03.1.1v.98c0 .07-.03.1-.1.1h-4.65c-.07 0-.1-.03-.1-.1Z"
  })));
};
export default SvgPointTwoicon;